import Logo from '@/components/logo/logo';
import styles from './reset-password.module.scss';
import { Flex, message } from 'antd';
import arrowImage from '@/assets/images/arrow.svg';
import {
  ResetPasswordFieldType,
  ResetPasswordForm,
} from '@/components/reset-password-form/reset-password-form';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '@/hooks/use-auth/use-auth';
import { useTranslation } from 'react-i18next';

export function ResetPassword() {
  const { t } = useTranslation('auth');
  const [searchParams] = useSearchParams();
  const resetToken = searchParams.get('reset_password_token');
  const [messageApi, contextHolder] = message.useMessage();

  const { sendNewPassword, errorSendingNewPassword, isPendingSendingNewPassword } = useAuth();
  const resetPassword = ({ password, password_confirmation }: ResetPasswordFieldType) => {
    sendNewPassword({
      password,
      password_confirmation,
      reset_password_token: resetToken || '',
    });
    messageApi.success(t('resetPassword.success'));
  };

  return (
    <>
      {contextHolder}
      <Flex vertical align="center">
        <Flex className={styles.logo}>
          <Logo />
        </Flex>
        <ResetPasswordForm
          error={errorSendingNewPassword?.message}
          onSubmit={resetPassword}
          isLoading={isPendingSendingNewPassword}
        />
        <img className={styles.arrow} src={arrowImage} />
      </Flex>
    </>
  );
}
